var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.05 1.555C0.150818 1.11324 0.398655 0.718813 0.752922 0.436308C1.10719 0.153804 1.54688 -3.04944e-05 2 4.53414e-09H14C14.4531 -3.04944e-05 14.8928 0.153804 15.2471 0.436308C15.6013 0.718813 15.8492 1.11324 15.95 1.555L8 6.414L0.05 1.555ZM0 2.697V9.801L5.803 6.243L0 2.697ZM6.761 6.83L0.191 10.857C0.353327 11.1993 0.609527 11.4884 0.929782 11.6908C1.25004 11.8931 1.62117 12.0004 2 12H14C14.3788 12.0001 14.7498 11.8926 15.0698 11.6901C15.3899 11.4876 15.6459 11.1983 15.808 10.856L9.238 6.829L8 7.586L6.761 6.83ZM10.197 6.244L16 9.801V2.697L10.197 6.244Z",
    fill: "#606588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.514bbdbd9e5a43ee07170bdd38c789b0.svg";
export { ForwardRef as ReactComponent };